export const getAssetName = (path?: string) => {
  return path && path.substring(path.lastIndexOf("/") + 1);
};
